import { useHistory, useLocation } from "react-router-dom";
import React from "react";
import Button from "components/lbc-toolkit/atomics/Button/DefaultButton";
import translations from "translations";
import { useStyles } from "../MoodleModuleAdd";

const MoodleModuleAddButton: React.FC<{}> = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();

  function handleClick() {
    history.push(`addMoodleModule`);
  }

  return (
    <Button
      label={`${translations.pages.produkte.module.label} ${translations.globals.button.plan}`}
      buttonType="primary"
      onClick={handleClick}
      classes={{ colorPrimary: classes.addButton }}
    />
  );
};
export default MoodleModuleAddButton;
